import React, { useState, useMemo, useRef } from "react";
import ModalBox from "../../../../components/modal/ModalBox";
import { Input, TextArea } from "../../../../components/Form";
import { optimizeFunction } from "../../../../utils/regex";
import useButtonLoader from "../../../../hooks/UseButtonLoader";
import { toastMessage } from "../../../../utils/toastMessage";
import { addSkillApi } from "../../../../services/skills";
import { Avatar } from "@mui/material";
import { checkImageDimensions } from "../../../../utils/checkImageDimension";
import commonMessages from "../../../../utils/commonMessages";
import { regex } from "../../../../utils/regex";
import JoditEditor from "jodit-react";

const AddSkills = ({
  setAddModal,
  addModal,
  getCmsDetails,
  userType,
  type,
}) => {
  const [buttonref, buttonLoader] = useButtonLoader("Save");
  const [skillInput, setSkillInput] = useState("");
  const [skillImage, setSkillImage] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState({});
  const { IMAGE_FORMAT } = commonMessages;
  const { imageFileRegex } = regex;
  const {MESSAGE_SIZE}=commonMessages;
  const editor = useRef(null);

  const editorConfig = useMemo(
    () => ({
      readonly: false,
      placeholder: "Enter skill description...",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
    }),
    []
  );

  //   console.log(userType,type);

  const modalClose = () => {
    setError({});
    setSkillInput("");
    setSkillImage("");
    setBannerImage("");
    setDescription("");
    setAddModal(false);
  };

  const validation = () => {
    let status = true;
    const errors = {};
    if (!skillInput) {
      errors["title"] = "Skill is mandatory";
      status = false;
    }
    if (!skillImage) {
      errors["skillImage"] = "Image is Mandatory";
      status = false;
    }
    setError(errors);
    return status;
  };

  const imageHandler = async (e) => {
    e.preventDefault();
    if (e.target.files.length > 0) {
      if (imageFileRegex.test(e.target.files[0].name)) {
        // const validSize = await checkImageDimensions(e.target.files[0]);
        // if (validSize) {
          setSkillImage(e.target.files[0]);
        // } else {
        //   e.target.value = "";
        //   setSkillImage("");
        // }
      } else {
        e.target.value = "";
        setSkillImage("");
        toastMessage(IMAGE_FORMAT, "error", "imageFormat");
      }
    } else {
      e.target.value = "";
      setSkillImage("");
    }
  };

  const bannerImageHandler = async (e) => {
    e.preventDefault();
    if (e.target.files.length > 0) {
      if (imageFileRegex.test(e.target.files[0].name)) {
        setBannerImage(e.target.files[0]);
      } else {
        e.target.value = "";
        setBannerImage("");
        toastMessage(IMAGE_FORMAT, "error", "imageFormat");
      }
    } else {
      e.target.value = "";
      setBannerImage("");
    }
  };

  const addSkillHandler = async () => {
    if (validation()) {
      try {
        buttonLoader(true);
        const formData = new FormData();
        formData.append("title", skillInput);
        formData.append("userType", userType);
        formData.append("description", description || "");
        if (skillImage && skillImage?.name) {
          formData.append("image", skillImage);
        }
        if (bannerImage && bannerImage?.name) {
          formData.append("bannerImage", bannerImage);
        }
        const { data } = await addSkillApi(formData);
        if (data.success) {
          toastMessage(data.message || "Skill added successfully", "success", "addSkill");
          setSkillImage("");
          setBannerImage("");
          setSkillInput("");
          setDescription("");
          setError({});
          getCmsDetails();
          modalClose();
        } else {
          toastMessage(data.message || "Failed to add skill", "error", "addSkill");
        }
      } catch (error) {
        console.log("error", error);
        toastMessage(error?.response?.data?.message || "Error adding skill", "error", "addSkill");
      } finally {
        buttonLoader(false);
      }
    }
  };
  return (
    <ModalBox
      status={addModal}
      onClose={modalClose}
      title={"Add Skill"}
      closeIcon
      size={"lg"}
      custom
      customizedFooter={
        <div className="model_custom_footer">
             {/* <p>{MESSAGE_SIZE}</p> */}
        <button className="btn_size" ref={buttonref} onClick={addSkillHandler}>
          Save
        </button>
        </div>
      }
    >
      <div>
        <div className="form-group mb-2">
          <Input
            type="text"
            name="title"
            value={skillInput || ""}
            required
            onChange={(e) => {
              const sanitizedText = optimizeFunction(e.target.value);
              setSkillInput(sanitizedText);
            }}
            placeholder="Skill"
            className={`form-control`}
            label={"Skill"}
            error={!skillInput && error.title}
            maxLength={40}
          />
        </div>
        <div className="form-group my-2">
          <Input
            type="file"
            accept="image/*"
            name="skillImage"
            // value={image.name || ''}
            required
            onChange={(e) => imageHandler(e)}
            placeholder="Skill Image"
            className={`form-control `}
            label={"Skill Image"}
            error={!skillImage && error.skillImage}
          />
        </div>

        <div>
          {skillImage && (
            <>
              <Avatar
                variant="square"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  height: 140,
                  border: "1px solid #FF8989",
                  mb: 2
                }}
                src={skillImage && URL.createObjectURL(skillImage)}
              />
            </>
          )}
        </div>

        <div className="form-group my-2">
          <Input
            type="file"
            accept="image/*"
            name="bannerImage"
            onChange={(e) => bannerImageHandler(e)}
            placeholder="Banner Image"
            className={`form-control `}
            label={"Banner Image (Optional)"}
          />
        </div>

        <div>
          {bannerImage && (
            <>
              <Avatar
                variant="square"
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  height: 200,
                  border: "1px solid #FF8989",
                  mb: 2
                }}
                src={bannerImage && URL.createObjectURL(bannerImage)}
              />
            </>
          )}
        </div>

        <div className="form-group my-2">
          <label className="form-label">Description</label>
          <JoditEditor
            ref={editor}
            value={description}
            tabIndex={1}
            onBlur={(newContent) => setDescription(newContent)}
            config={editorConfig}
          />
        </div>
      </div>
    </ModalBox>
  );
};

export default AddSkills;
